const gameAction = {
    reset: (state) => {
        state.gameStatus = {
            inProgress: false,
            buzzIn: null,
            contestants: {
                "RGF2ZQ==": {"id": "RGF2ZQ==", "name": "Dave", "score": 0, "avatar": "0"},
                "Sm9l": {"id": "Sm9l", "name": "Joe", "score": 0, "avatar": "1"},
                "QW5uYQ==": {"id": "QW5uYQ==", "name": "Anna", "score": 0, "avatar": "2"},
                "Sm9zZXBo": {"id": "Sm9zZXBo", "name": "Joseph", "score": 0, "avatar": "3"},
                "QW5pbA==": {"id": "QW5pbA==", "name": "Anil", "score": 0, "avatar": "4"}
            },
            pictures: {
                img1: {
                    name: 'Image 1',
                    source: 'img1.jpg'
                },
                img2: {
                    name: 'Image 2',
                    source: 'img2.jpg'
                }
            },
            pictureId: null
        };
    },
    addContestant: (id, state) => {
        if (!state.gameStatus.contestants[id]) {
            state.gameStatus.contestants[id] = {
                id: id,
                name: new Buffer(id, 'base64').toString(),
                score: 0,
                avatar: (Object.keys(state.gameStatus.contestants).length % 10).toString(),
            };
        }
    },
    removeContestant: (id, state) => {
        delete state.gameStatus.contestants[id];
    },
    start: (state) => {
        state.gameStatus.buzzIn = undefined;
        state.gameStatus.inProgress = true;
    },
    stop: (state) => {
        state.gameStatus.inProgress = false;
    },
    addPoint: (id, state) => {
        if (state.gameStatus.inProgress) {
            state.gameStatus.contestants[id].score++;
        }
    },
    deductPoint: (id, state) => {
        if (state.gameStatus.inProgress) {
            state.gameStatus.contestants[id].score--;
        }
    },
    buzzIn: (id, state) => {
        if (!state.gameStatus.inProgress || !state.gameStatus.buzzIn) {
            state.gameStatus.buzzIn = id;
        }
    },
    buzzOut: (state) => {
        state.gameStatus.buzzIn = undefined;
    },
    setPicture: (id, state) => {
        state.gameStatus.pictureId = id;
    },
}

const standAloneState = {};
gameAction.reset(standAloneState);

const getAction = (state, request, payload) => {
    const action = request.split('/')[2];
    const id = payload ? payload.id : undefined;

    switch (action) {
        case 'status':
            break;
        case 'addContestant':
            gameAction.addContestant(id, state);
            break;
        case 'removeContestant':
            gameAction.removeContestant(id, state);
            break;
        case 'addPoint':
            gameAction.addPoint(id, state);
            break;
        case 'deductPoint':
            gameAction.deductPoint(id, state);
            break;
        case 'buzzIn':
            gameAction.buzzIn(id, state);
            break;
        case 'reset':
            gameAction.reset(state);
            break;
        case 'start':
            gameAction.start(state);
            break;
        case 'stop':
            gameAction.stop(state);
            break;
        case 'buzzOut':
            gameAction.buzzOut(state);
            break;
        case 'setPicture':
            gameAction.setPicture(id, state);
            break;
    }
    const stateClone = JSON.parse(JSON.stringify(state));
    const resp = {data: stateClone.gameStatus};
    return resp;
}

const standAloneGet = (request, payload) => {
    return new Promise((call) => {
        call(getAction(standAloneState, request, payload));
    });
}

export default standAloneGet;
